<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px" @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-input v-model.trim="filteForm.oldmanName" placeholder="请输入老人姓名" clearable @keyup.enter.native="onSubmit" />
        </el-form-item>
        <el-form-item label="护理组">
          <el-select v-model="filteForm.nursingGroupId" clearable placeholder="请选择护理组" style="width:160px">
            <el-option v-for="g in nursingGroupList" :key="g.id" :label="g.name" :value="g.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="计划状态">
          <el-select v-model="filteForm.status" clearable placeholder="全部" style="width:120px">
            <el-option label="生效中" :value="1" />
            <el-option label="已终止" :value="2" />
            <el-option label="已失效" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="自理等级">
          <el-select v-model="filteForm.selfCareLevel" clearable placeholder="全部" style="width:120px">
            <el-option label="自理" :value="1" />
            <el-option label="半自理" :value="2" />
            <el-option label="不能自理" :value="3" />
            <el-option label="重度失能" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="生效日期">
          <el-date-picker v-model="filteForm.effectiveDateRange" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:240px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
          <el-button icon="el-icon-refresh" plain @click="resetForm">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="showAddForm">新增计划</el-button>
          <el-button type="info" icon="el-icon-download" plain @click="exportExcel">导出</el-button>
        </el-form-item>
      </el-form>

      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="dataList" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="计划编号" align="center" prop="planNo" width="160" />
          <el-table-column label="老人姓名" align="center" prop="oldmanName" width="100" />
          <el-table-column label="床位" align="center" prop="bedNo" width="90" />
          <el-table-column label="护理组" align="center" prop="nursingGroupName" width="120" />
          <el-table-column label="计划类型" align="center" width="90">
            <template slot-scope="scope">{{ planTypeText(scope.row.planType) }}</template>
          </el-table-column>
          <el-table-column label="项目数" align="center" prop="projectCount" width="80" />
          <el-table-column label="生效日期" align="center" prop="effectiveDate" width="110" />
          <el-table-column label="失效日期" align="center" prop="expireDate" width="110" />
          <el-table-column label="状态" align="center" width="90">
            <template slot-scope="scope">
              <el-tag :type="statusTagType(scope.row.status)" size="mini">{{ statusText(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="handleDetail(scope.row)">查看</el-button>
              <el-button v-if="scope.row.status === 1" type="warning" size="mini" plain @click="handleEdit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.status === 1" type="danger" size="mini" plain @click="handleTerminate(scope.row)">终止</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="filteForm.pageNum"
          layout="total, prev, pager, next" :total="totalDataNumber" align="center" class="fenye" />
      </div>

      <!-- 新增/编辑弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="900px"
        append-to-body
        :close-on-click-modal="false" @close="closeDialog">
        <el-form ref="form" :model="addForm" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="16">
              <el-form-item label="老人姓名" required>
                <el-autocomplete
                  v-model.trim="addForm.oldmanName"
                  placeholder="输入姓名检索或点击下拉"
                  style="width:100%"
                  clearable
                  :fetch-suggestions="queryOlder"
                  :trigger-on-focus="true"
                  popper-class="care-plan-oldman-autocomplete"
                  @select="selectOld"
                  :disabled="isEdit"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="床位">
                <el-input v-model.trim="addForm.bedNo" placeholder="选择老人后自动带出，可手动填写" :readonly="isEdit" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="自理等级">
                <el-select v-model="addForm.selfCareLevel" placeholder="请选择" style="width:100%">
                  <el-option label="自理" :value="1" />
                  <el-option label="半自理" :value="2" />
                  <el-option label="不能自理" :value="3" />
                  <el-option label="重度失能" :value="4" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="护理组" required>
                <el-select v-model="addForm.nursingGroupId" placeholder="请选择护理组" style="width:100%" @change="onGroupChange">
                  <el-option v-for="g in nursingGroupList" :key="g.id" :label="g.name" :value="g.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="班次" required>
                <el-select v-model="addForm.shiftType" placeholder="请选择班次" style="width:100%">
                  <el-option label="白班" value="day" />
                  <el-option label="夜班" value="night" />
                  <el-option label="中班" value="middle" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="分配模式" required>
                <el-select v-model="addForm.assignMode" placeholder="请选择" style="width:100%">
                  <el-option label="抢单" :value="1" />
                  <el-option label="指派" :value="2" />
                  <el-option label="轮排" :value="3" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="计划类型" required>
                <el-radio-group v-model="addForm.planType">
                  <el-radio :label="1">常规</el-radio>
                  <el-radio :label="2">临时</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="计划有效期" required>
                <el-date-picker
                  v-model="addForm.effectiveDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="生效开始日期"
                  end-placeholder="失效/结束日期"
                  value-format="yyyy-MM-dd"
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="来源模板">
                <el-select v-model="addForm.templateId" clearable placeholder="可选模板" style="width:100%" @change="onTemplateChange">
                  <el-option v-for="t in templateList" :key="t.id" :label="t.templateName" :value="t.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="护理项目" required>
                <el-button type="primary" size="mini" plain @click="addProjectRow">添加项目</el-button>
                <el-table :data="addForm.items" border size="mini" style="margin-top:8px">
                  <el-table-column label="护理项目" min-width="140">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.projectId" placeholder="选择项目" filterable clearable
                        popper-append-to-body style="width:100%"
                        @change="val => onProjectSelect(scope.row, val)">
                        <el-option v-for="p in projectList" :key="p.id" :label="p.projectName" :value="p.id" />
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="频率" min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model.trim="scope.row.execFrequency" clearable placeholder="如：每天、每周2次、daily" />
                    </template>
                  </el-table-column>
                  <el-table-column label="执行时间" width="150">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.execTimes" placeholder="如08:00,14:00" />
                    </template>
                  </el-table-column>
                  <el-table-column label="时长(分)" width="120">
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.duration"
                        :min="1"
                        :max="480"
                        :precision="0"
                        :controls="false"
                        placeholder="分钟"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="70" align="center">
                    <template slot-scope="scope">
                      <el-button type="danger" size="mini" plain @click="removeProjectRow(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model.trim="addForm.remark" type="textarea" :rows="2" />
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="isEdit">
              <el-form-item label="修改原因">
                <el-input v-model.trim="addForm.changeReason" placeholder="请填写修改原因" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submitForm" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 详情弹窗 -->
      <el-dialog title="护理计划详情" :visible.sync="detailVisible" width="800px" :close-on-click-modal="false">
        <el-descriptions :column="3" border size="small" v-if="detailData">
          <el-descriptions-item label="计划编号">{{ detailData.planNo }}</el-descriptions-item>
          <el-descriptions-item label="老人姓名">{{ detailData.oldmanName }}</el-descriptions-item>
          <el-descriptions-item label="床位">{{ detailData.bedNo }}</el-descriptions-item>
          <el-descriptions-item label="护理组">{{ detailData.nursingGroupName }}</el-descriptions-item>
          <el-descriptions-item label="计划类型">{{ planTypeText(detailData.planType) }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ statusText(detailData.status) }}</el-descriptions-item>
          <el-descriptions-item label="生效日期">{{ detailData.effectiveDate }}</el-descriptions-item>
          <el-descriptions-item label="失效日期">{{ detailData.expireDate || '-' }}</el-descriptions-item>
          <el-descriptions-item label="分配模式">{{ assignModeText(detailData.assignMode) }}</el-descriptions-item>
        </el-descriptions>
        <el-table :data="detailData.items || []" border size="mini" style="margin-top:12px">
          <el-table-column label="护理项目" prop="projectName" />
          <el-table-column label="频率" prop="execFrequency" width="90" />
          <el-table-column label="执行时间" prop="execTimes" width="140" />
          <el-table-column label="时长(分)" prop="duration" width="90" />
        </el-table>
        <el-table v-if="detailData.changeLogs && detailData.changeLogs.length" :data="detailData.changeLogs"
          border size="mini" style="margin-top:12px">
          <el-table-column label="修改时间" prop="changeTime" width="160" />
          <el-table-column label="修改人" prop="operator" width="100" />
          <el-table-column label="修改内容" prop="changeContent" />
          <el-table-column label="修改原因" prop="changeReason" />
        </el-table>
      </el-dialog>

      <!-- 终止弹窗 -->
      <el-dialog title="终止护理计划" :visible.sync="terminateVisible" width="480px" :close-on-click-modal="false">
        <el-form label-width="90px">
          <el-form-item label="终止原因" required>
            <el-input v-model.trim="terminateForm.terminateReason" type="textarea" :rows="3" placeholder="请填写终止原因" />
          </el-form-item>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="terminateVisible = false">取 消</el-button>
          <el-button type="danger" :loading="terminateLoading" @click="submitTerminate">确认终止</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { postDownload } from "@/utils/request.js";
export default {
  name: "CarePlanList",
  data() {
    return {
      filteForm: {
        oldmanName: "",
        nursingGroupId: null,
        status: null,
        selfCareLevel: null,
        effectiveDateRange: null,
        pageNum: 1,
        pageSize: 20
      },
      dataList: [],
      totalDataNumber: 0,
      loading: false,
      nursingGroupList: [],
      projectList: [],
      templateList: [],
      dialogFormVisible: false,
      dialogTitle: "新增护理计划",
      isEdit: false,
      addForm: { planType: 1, assignMode: 1, items: [] },
      addLoading: false,
      detailVisible: false,
      detailData: {},
      terminateVisible: false,
      terminateForm: {},
      terminateLoading: false
    };
  },
  methods: {
    onSubmit() {
      this.filteForm.pageNum = 1;
      this.getTableData();
    },
    resetForm() {
      this.filteForm = {
        oldmanName: "",
        nursingGroupId: null,
        status: null,
        selfCareLevel: null,
        effectiveDateRange: null,
        pageNum: 1,
        pageSize: 20
      };
      this.getTableData();
    },
    showAddForm() {
      this.isEdit = false;
      this.dialogTitle = "新增护理计划";
      this.resetAddForm();
      this.dialogFormVisible = true;
      this.loadNursingGroups();
      this.loadTemplates();
      this.loadProjects();
    },
    resetAddForm() {
      this.addForm = {
        planType: 1,
        assignMode: 1,
        shiftType: "day",
        items: [],
        bedNo: "",
        oldmanName: "",
        oldmanId: null,
        nursingGroupId: null,
        selfCareLevel: null,
        effectiveDate: "",
        expireDate: "",
        effectiveDateRange: null,
        templateId: null,
        remark: ""
      };
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = "修改护理计划";
      this.$postJson("omc/carePlan/detail", { id: row.id }).then(res => {
        if (res.code == 200) {
          const d = res.result || {};
          this.addForm = Object.assign({}, d, { items: this.normalizeItems(d.items), changeReason: "" });
          const start = d.effectiveDate;
          const end = d.expireDate || d.effectiveDate;
          this.$set(this.addForm, "effectiveDateRange", start ? [start, end || start] : null);
          this.dialogFormVisible = true;
          this.loadNursingGroups();
          this.loadTemplates();
          this.loadProjects();
        }
      });
    },
    handleDetail(row) {
      this.$postJson("omc/carePlan/detail", { id: row.id }).then(res => {
        if (res.code == 200) {
          this.detailData = res.result || {};
          this.detailVisible = true;
        }
      });
    },
    handleTerminate(row) {
      this.terminateForm = { id: row.id, terminateReason: "" };
      this.terminateVisible = true;
    },
    submitTerminate() {
      if (!this.terminateForm.terminateReason) {
        this.$message.warning("请填写终止原因");
        return;
      }
      this.terminateLoading = true;
      this.$postJson("omc/carePlan/terminate", this.terminateForm).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message || "终止成功");
          this.terminateVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => { this.terminateLoading = false; });
    },
    queryOlder(queryString, cb) {
      const q = queryString != null ? String(queryString).trim() : "";
      this.$postJson("omc/queryMachine/queryOldmanList", { oldName: q, pageNum: 1, pageSize: 50 })
        .then(res => {
          if (!res || res.code != 200) {
            cb([]);
            return;
          }
          const data = res.result;
          const list = (data && data.list) ? data.list : [];
          cb(list.map(o => ({ value: o.oldName, old: o })));
        })
        .catch(() => cb([]));
    },
    selectOld(item) {
      const o = item.old || item;
      this.addForm.oldmanId = o.oldmanId;
      this.addForm.oldmanName = o.oldName || item.value;
      this.$set(this.addForm, "bedNo", o.bedNo || "");
    },
    onGroupChange(val) {
      const group = this.nursingGroupList.find(g => g.id === val);
      this.addForm.nursingGroupName = group ? group.name : "";
    },
    onTemplateChange(val) {
      if (!val) return;
      this.$postJson("omc/nursingTemplate/detail", { id: val }).then(res => {
        if (res.code == 200 && res.result) {
          const t = res.result;
          this.addForm.templateName = t.templateName;
          this.addForm.selfCareLevel = t.selfCareLevel;
          this.addForm.items = this.normalizeItems(t.items);
        }
      });
    },
    normalizeItems(items) {
      return (items || []).map(it => ({
        ...it,
        duration: it.duration != null && it.duration !== "" ? Number(it.duration) : 30
      }));
    },
    onProjectSelect(row, projectId) {
      const project = this.projectList.find(p => p.id === projectId);
      if (project) {
        row.projectName = project.projectName;
        row.projectCategory = project.category;
        const d = project.defaultDuration != null ? Number(project.defaultDuration) : 30;
        this.$set(row, "duration", d > 0 ? d : 30);
      }
    },
    addProjectRow() {
      if (!this.addForm.items) this.addForm.items = [];
      this.addForm.items.push({ execFrequency: "", duration: 30, execTimes: "" });
    },
    removeProjectRow(index) {
      this.addForm.items.splice(index, 1);
    },
    closeDialog() {
      this.dialogFormVisible = false;
      this.isEdit = false;
      this.resetAddForm();
    },
    submitForm() {
      if (!this.addForm.oldmanId) return this.$message.warning("请选择老人");
      if (!this.addForm.nursingGroupId) return this.$message.warning("请选择护理组");
      if (!this.addForm.items || !this.addForm.items.length) return this.$message.warning("请添加护理项目");
      if (!this.addForm.effectiveDateRange || this.addForm.effectiveDateRange.length !== 2) {
        return this.$message.warning("请选择计划有效期（开始–结束日期）");
      }
      const [effectiveDate, expireDate] = this.addForm.effectiveDateRange;
      const payload = Object.assign({}, this.addForm, { effectiveDate, expireDate });
      delete payload.effectiveDateRange;
      this.addLoading = true;
      const url = this.isEdit ? "omc/carePlan/modify" : "omc/carePlan/add";
      this.$postJson(url, payload).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message || "保存成功");
          this.closeDialog();
          this.getTableData();
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => { this.addLoading = false; });
    },
    exportExcel() {
      const param = {
        oldmanName: this.filteForm.oldmanName || undefined,
        nursingGroupId: this.filteForm.nursingGroupId || undefined,
        status: this.filteForm.status || undefined,
        selfCareLevel: this.filteForm.selfCareLevel || undefined,
        effectiveDateStart: this.filteForm.effectiveDateRange ? this.filteForm.effectiveDateRange[0] : undefined,
        effectiveDateEnd: this.filteForm.effectiveDateRange ? this.filteForm.effectiveDateRange[1] : undefined
      };
      postDownload("omc/carePlan/export", "护理计划.xls", param);
    },
    getTableData() {
      const param = {
        pageNum: this.filteForm.pageNum,
        pageSize: this.filteForm.pageSize,
        oldmanName: this.filteForm.oldmanName || undefined,
        nursingGroupId: this.filteForm.nursingGroupId || undefined,
        status: this.filteForm.status || undefined,
        selfCareLevel: this.filteForm.selfCareLevel || undefined,
        effectiveDateStart: this.filteForm.effectiveDateRange ? this.filteForm.effectiveDateRange[0] : undefined,
        effectiveDateEnd: this.filteForm.effectiveDateRange ? this.filteForm.effectiveDateRange[1] : undefined
      };
      this.loading = true;
      this.$postJson("omc/carePlan/queryListWithPage", param).then(res => {
        if (res.result) {
          this.dataList = res.result.list || [];
          this.totalDataNumber = Number(res.result.total) || 0;
        } else {
          this.dataList = [];
          this.totalDataNumber = 0;
        }
      }).finally(() => { this.loading = false; });
    },
    loadNursingGroups() {
      this.$postForm("omc/group/selectShowAll", {}).then(res => {
        if (!res || res.code != 200) {
          this.nursingGroupList = [];
          return;
        }
        const data = res.result;
        this.nursingGroupList = Array.isArray(data) ? data : [];
      }).catch(() => { this.nursingGroupList = []; });
    },
    loadTemplates() {
      this.$postJson("omc/nursingTemplate/queryListWithPage", { pageNum: 1, pageSize: 200, status: 1 }).then(res => {
        if (!res || res.code != 200) {
          this.templateList = [];
          return;
        }
        const data = res.result;
        if (Array.isArray(data)) {
          this.templateList = data;
        } else {
          this.templateList = (data && data.list) ? data.list : [];
        }
      }).catch(() => { this.templateList = []; });
    },
    loadProjects() {
      const parse = res => {
        if (!res || res.code != 200) return [];
        const data = res.result;
        if (Array.isArray(data)) return data;
        return (data && data.list) ? data.list : [];
      };
      this.$postJson("omc/nursingProject/listEnabled", {})
        .then(res => {
          this.projectList = parse(res);
          if (!this.projectList.length) {
            return this.$postJson("omc/nursingProject/queryListWithPage", { pageNum: 1, pageSize: 500, status: 1 });
          }
        })
        .then(res => { if (res) this.projectList = parse(res); })
        .catch(() => {
          this.$postJson("omc/nursingProject/queryListWithPage", { pageNum: 1, pageSize: 500, status: 1 })
            .then(res => { this.projectList = parse(res); });
        });
    },
    handleCurrentChange(val) {
      this.filteForm.pageNum = val;
      this.getTableData();
    },
    planTypeText(v) { return v === 1 ? "常规" : "临时"; },
    statusText(v) {
      if (v === 1) return "生效中";
      if (v === 2) return "已终止";
      return "已失效";
    },
    statusTagType(v) {
      if (v === 1) return "success";
      if (v === 2) return "info";
      return "warning";
    },
    assignModeText(v) {
      if (v === 1) return "抢单";
      if (v === 2) return "指派";
      return "轮排";
    },
    tableRowStyle() { return "background-color: #ffffff"; },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 14px;background-color: #d4f5fa;";
    }
  },
  created() {
    this.loadNursingGroups();
    this.loadProjects();
    this.loadTemplates();
  },
  mounted() {
    this.getTableData();
  }
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m { padding: 10px 0 0 5px; }
}
.fenye {
  margin: 0;
  padding: 20px 0;
  background: #fff;
}
</style>
